import { DateFilterValue } from '../state/option-ids-visible/search-filter-options.models';

export enum SearchType {
  all = 'ALL',
  exhibitor = 'EXHIBITOR',
  brand = 'BRAND',
  product = 'PRODUCT',
  event = 'EVENT',
  post = 'POST',
}

export interface SearchTypeOption {
  value: SearchType;
  label: string;
  resultLabels: {
    default: string;
    plural: string;
  };
  disabled?: boolean;
}

export const searchTypeOptions = {
  ALL: {
    value: SearchType.all,
    label: $localize`:@@featureSearch-searchType-all:Alle`,
    resultLabels: {
      default: $localize`:@@featureSearch-searchType-all-default-result:Ergebnis`,
      plural: $localize`:@@featureSearch-searchType-all-plural-result:Ergebnisse`,
    },
  },
  EXHIBITOR: {
    value: SearchType.exhibitor,
    label: $localize`:@@featureSearch-searchType-exhibitor:Aussteller`,
    resultLabels: {
      default: $localize`:@@featureSearch-searchType-exhibitor-default-result:Aussteller`,
      plural: $localize`:@@featureSearch-searchType-exhibitor-plural-result:Aussteller`,
    },
  },
  BRAND: {
    value: SearchType.brand,
    label: $localize`:@@featureSearch-searchType-brand:Marke`,
    resultLabels: {
      default: $localize`:@@featureSearch-searchType-brand-default-result:Marke`,
      plural: $localize`:@@featureSearch-searchType-brand-plural-result:Marken`,
    },
    disabled: true,
  },
  PRODUCT: {
    value: SearchType.product,
    label: $localize`:@@featureSearch-searchType-product:Produkte`,
    resultLabels: {
      default: $localize`:@@featureSearch-searchType-product-default-result:Produkt`,
      plural: $localize`:@@featureSearch-searchType-product-plural-result:Produkte`,
    },
  },
  POST: {
    value: SearchType.post,
    label: $localize`:@@featureSearch-searchType-post:Beiträge`,
    resultLabels: {
      default: $localize`:@@featureSearch-searchType-post-default-result:Beitrag`,
      plural: $localize`:@@featureSearch-searchType-post-plural-result:Beiträge`,
    },
  },
  EVENT: {
    value: SearchType.event,
    label: $localize`:@@featureSearch-searchType-event:Events`,
    resultLabels: {
      default: $localize`:@@featureSearch-searchType-event-default-result:Event`,
      plural: $localize`:@@featureSearch-searchType-event-plural-result:Events`,
    },
  },
};

export const searchTypes: SearchTypeOption[] = Object.values(searchTypeOptions);

export enum SearchSortOrder {
  recommended = 'RECOMMENDED_DESC',
  alphabeticalAsc = 'ALPHABETICAL_ASC',
  alphabeticalDesc = 'ALPHABETICAL_DESC',
  dateAsc = 'DATE_ASC',
  dateDesc = 'DATE_DESC',
  exhibitionHallsAsc = 'EXHIBITION-HALLS_ASC',
  exhibitionHallsDesc = 'EXHIBITION-HALLS_DESC',
}

export interface SearchStringFilter {
  name: string;
  filters: string[];
}

export interface SearchFilters {
  searchTypes?: SearchType[];
  searchTerm?: string;
  page?: string;
  searchSort?: SearchSortOrder;
  stringFilter?: SearchStringFilter[];
  dateFilter?: DateFilterValue[];
}
